import React from 'react';

// Company logo images from the public/images/logosbcm folder
const logoImages = [
  '/images/logosbcm/Screenshot_2025-12-04_at_15.29.53-removebg-preview.png',
  '/images/logosbcm/Screenshot_2025-12-04_at_15.30.17-removebg-preview.png',
  '/images/logosbcm/Screenshot_2025-12-04_at_15.30.24-removebg-preview.png',
  '/images/logosbcm/Screenshot_2025-12-04_at_15.30.36-removebg-preview.png',
  '/images/logosbcm/Screenshot_2025-12-04_at_15.30.40-removebg-preview.png',
];

export default function LogoCarousel() {
  // Double the logos for seamless infinite scroll
  const doubled = [...logoImages, ...logoImages];

  return (
    <div className="py-12 overflow-hidden bg-gradient-to-br from-[#1a0b2e] via-[#16213e] to-[#0f3443]">
      <div className="relative">
        {/* Scrolling container - fade removed */}
        <div className="flex animate-scroll-left items-center">
          {doubled.map((src, index) => (
            <div
              key={"logo-" + index}
              className="flex-shrink-0 mx-8 md:mx-12"
            >
              <img
                src={src}
                alt={"Partner " + (index + 1)}
                className="h-10 md:h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
